/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  CLIENT_FETCH_REQUEST,
  CLIENT_FETCH_REQUEST_SUCCESS,
  CLIENT_FETCH_REQUEST_FAILURE,
  CLIENT_UPSERT_REQUEST,
  CLIENT_UPSERT_REQUEST_SUCCESS,
  CLIENT_UPSERT_REQUEST_FAILURE,
  CLIENT_TIMEZONE_FETCH_REQUEST_SUCCESS,
  CLIENT_CATEGORY_FETCH_REQUEST_SUCCESS,
  CLIENT_CLEAN_REQUEST,
  SINGLE_CLIENT_UPDATE_REQUEST,
  SINGLE_CLIENT_UPDATE_REQUEST_SUCCESS,
  SINGLE_CLIENT_UPDATE_REQUEST_FAILURE,
  SINGLE_CLIENT_FETCH_REQUEST,
  SINGLE_CLIENT_FETCH_REQUEST_SUCCESS,
  SINGLE_CLIENT_FETCH_REQUEST_FAILURE,
  MERGE_CLIENT_DETAIL_FETCH_REQUEST,
  MERGE_CLIENT_DETAIL_FETCH_REQUEST_SUCCESS,
  MERGE_CLIENT_DETAIL_FETCH_REQUEST_FAILURE,
  MERGE_CLIENT_DETAIL_CLEAN_REQUEST,
  CLIENT_FILING_STATUS_YEAR_UPDATE_REQUEST,
  CLIENT_FILING_STATUS_YEAR_UPDATE_REQUEST_SUCCESS,
  CLIENT_FILING_STATUS_YEAR_UPDATE_REQUEST_FAILURE,
  CLEAN_CLIENT_FILING_STATUS_YEAR_PROPS,
  DOCUMENT_SIGNER_FLIP_REQUEST,
  DOCUMENT_SIGNER_FLIP_REQUEST_SUCCESS,
  DOCUMENT_SIGNER_FLIP_REQUEST_FAILURE,
  SINGLE_CLIENT_CLEAN_REQUEST,
  CLIENT_REGISTER_REQUEST,
  CLIENT_REGISTER_REQUEST_SUCCESS,
  CLIENT_REGISTER_REQUEST_FAILURE,
  CLIENT_ASSOCIATION_FETCH_REQUEST,
  CLIENT_ASSOCIATION_FETCH_REQUEST_SUCCESS,
  CLIENT_ASSOCIATION_FETCH_REQUEST_FAILURE,
  CLIENT_ASSOCIATION_CLEAN_REQUEST,
  CLIENT_ASSOCIATION_ADD_REQUEST,
  CLIENT_ASSOCIATION_ADD_REQUEST_SUCCESS,
  CLIENT_ASSOCIATION_ADD_REQUEST_FAILURE,
  CLIENT_FILING_STATUS_FETCH_REQUEST_SUCCESS,
  CLIENT_APPOINMENT_MAX_DATE_FETCH_REQUEST,
  CLIENT_APPOINMENT_MAX_DATE_FETCH_REQUEST_SUCCESS,
  CLIENT_APPOINMENT_MAX_DATE_FETCH_REQUEST_FAILURE,
  CLIENT_FORGET_PASSWORD_FETCH_REQUEST,
  CLIENT_FORGET_PASSWORD_FETCH_REQUEST_SUCCESS,
  CLIENT_FORGET_PASSWORD_FETCH_REQUEST_FAILURE,
  CLIENT_DROPDOWN_FETCH_REQUEST,
  CLIENT_DROPDOWN_FETCH_REQUEST_SUCCESS,
  CLIENT_DROPDOWN_FETCH_REQUEST_FAILURE,
  CLIENT_SSN_FETCH_REQUEST,
  CLIENT_SSN_FETCH_REQUEST_SUCCESS,
  CLIENT_SSN_FETCH_REQUEST_FAILURE,
  CLIENT_STATE_FETCH_REQUEST_SUCCESS,
  UNLINKED_BUSINESS_CLIENT_FETCH_REQUEST,
  UNLINKED_BUSINESS_CLIENT_FETCH_REQUEST_SUCCESS,
  UNLINKED_BUSINESS_CLIENT_FETCH_REQUEST_FAILURE,
  LINK_ACCOUNT_REQUEST,
  LINK_ACCOUNT_REQUEST_SUCCESS,
  LINK_ACCOUNT_REQUEST_FAILURE,
  CLEAN_LINK_PROPS,
  SINGLE_ASSOCIATION_FETCH_REQUEST,
  SINGLE_ASSOCIATION_FETCH_REQUEST_SUCCESS,
  SINGLE_ASSOCIATION_FETCH_REQUEST_FAILURE,
  ASSOCIATION_UPSERT_REQUEST,
  ASSOCIATION_UPSERT_REQUEST_SUCCESS,
  ASSOCIATION_UPSERT_REQUEST_FAILURE,
  CLIENT_ASSOCIATION_SINGLE_CLEAN_REQUEST,
  CLIENT_DELETE_ERROR_CLEAN_REQUEST,
  CLIENT_DELETE_REQUEST,
  CLIENT_DELETE_REQUEST_SUCCESS,
  CLIENT_DELETE_REQUEST_FAILURE,
  ONBOARDING_CLIENT_DELETE_REQUEST,
  ONBOARDING_CLIENT_DELETE_REQUEST_SUCCESS,
  ONBOARDING_CLIENT_DELETE_REQUEST_FAILURE,
  ONBOARDING_CLIENT_CLEAN_REQUEST,
  CLIENT_DROPDOWN_BY_TAX_REPRESENTATIVE_FETCH_REQUEST,
  CLIENT_DROPDOWN_BY_TAX_REPRESENTATIVE_FETCH_REQUEST_SUCCESS,
  CLIENT_DROPDOWN_BY_TAX_REPRESENTATIVE_FETCH_REQUEST_FAILURE,
  REQUEST_FOR_CLIENT_DELETE,
  REQUEST_FOR_CLIENT_DELETE_SUCCESS,
  REQUEST_FOR_CLIENT_DELETE_FAILURE,
  CONFIRM_CLIENT_DELETE_REQUEST,
  CONFIRM_CLIENT_DELETE_REQUEST_SUCCESS,
  CONFIRM_CLIENT_DELETE_REQUEST_FAILURE,
  CLEAN_CLIENT_DELETE_PROPS,
  ASSOCIATION_SHARE_REQUEST,
  ASSOCIATION_SHARE_REQUEST_SUCCESS,
  ASSOCIATION_SHARE_REQUEST_FAILURE,
  ASSOCIATION_SUMMARY_FETCH_REQUEST,
  ASSOCIATION_SUMMARY_FETCH_REQUEST_SUCCESS,
  ASSOCIATION_SUMMARY_FETCH_REQUEST_FAILURE,
  CLEAN_ASSOCIATION_SUMMARY,
  CLEAN_TAX_FILING_STATUS,
  FETCH_CLIENTS_TERMS_AND_CONDITION_REQUEST,
  FETCH_CLIENTS_TERMS_AND_CONDITION_REQUEST_SUCCESS,
  FETCH_CLIENTS_TERMS_AND_CONDITION_REQUEST_FAILURE,
  UPDATE_TAXREPRESENTATIVE_IN_BULK_REQUEST,
  UPDATE_TAXREPRESENTATIVE_IN_BULK_REQUEST_SUCCESS,
  UPDATE_TAXREPRESENTATIVE_IN_BULK_REQUEST_FAILURE,
  CLEAN_TAXREPRESENTATIVE_CHANGE_STATUS,
  FETCH_CONDITIONS_TO_UPDATE_CLIENT_REQUEST,
  FETCH_CONDITIONS_TO_UPDATE_CLIENT_REQUEST_SUCCESS,
  FETCH_CONDITIONS_TO_UPDATE_CLIENT_REQUEST_FAILURE,
  FETCH_CLIENT_ACTIVITY_LOG_REQUEST,
  FETCH_CLIENT_ACTIVITY_LOG_REQUEST_SUCCESS,
  FETCH_CLIENT_ACTIVITY_LOG_REQUEST_FAILURE,
  CLEAN_CLIENT_ERROR_PROPS,
  DELETE_CLIENT_PROPS_CLEAN,
  CHECK_VALID_SSN_REQUEST,
  CHECK_VALID_SSN_REQUEST_SUCCESS,
  CHECK_VALID_SSN_REQUEST_FAILURE,
  CLEAN_SSN_VALIDATION,
  CHECK_VALID_EMAIL_REQUEST,
  CHECK_VALID_EMAIL_REQUEST_SUCCESS,
  CHECK_VALID_EMAIL_REQUEST_FAILURE,
  CLEAN_EMAIL_REQUEST,
  CLIENT_FIELD_TEMPLATE_FETCH_REQUEST,
  CLIENT_FIELD_TEMPLATE_FETCH_REQUEST_SUCCESS,
  CLIENT_FIELD_TEMPLATE_FETCH_REQUEST_FAILURE,
  CLIENT_ALL_LIST_FETCH_REQUEST,
  CLIENT_ALL_LIST_FETCH_REQUEST_FAILURE,
  CLIENT_ALL_LIST_FETCH_REQUEST_SUCCESS,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  singlePayload: [],
  singleLoading: false,
  singleErrors: {},
  mergeClientDetail: [],
  mergeClientDetailLoading: false,
  mergeClientDetailErrors: {},
  filingStatusYearPayload: [],
  filingStatusYearLoading: false,
  filingStatusYearErrors: {},
  documentSignerFlipLoading: false,
  documentSignerFlipErrors: {},
  category: [],
  timeZone: [],
  state: [],
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  filingStatus: [],
  maxDatePayload: [],
  maxDateLoading: false,
  maxDateErrors: {},
  clientDropdownPayload: [],
  clientDropdownLoading: false,
  clientDropdownErrors: {},
  clientSSNPayload: [],
  clientSSNLoading: false,
  clientSSNErrors: {},
  deletePayload: [],
  deleteLoading: false,
  deleteErrors: {},
  deleteOnboardingClientPayload: [],
  deleteOnboardingClientLoading: false,
  deleteOnboardingClientError: {},
  clientDropdownByTaxRepresentativePayload: [],
  clientDropdownByTaxRepresentativeLoading: false,
  clientDropdownByTaxRepresentativeErrors: {},
  deleteRequest: [],
  deleteRequestLoading: false,
  deleteRequestErrors: {},
  confirmDelete: [],
  confirmDeleteLoading: false,
  confirmDeleteErrors: {},
  associationSummary: [],
  associationSummaryLoading: false,
  associationSummaryErrors: {},
  termsAndCondition: [],
  termsAndConditionLoading: false,
  termsAndConditionErrors: {},
  updateTaxRepresentative: [],
  taxRepresentativeUpdating: false,
  taxRepresentativeUpdatingErrors: {},
  bulkUpdatePayload: [],
  bulkUpdateLoading: false,
  bulkUpdateError: {},
  clientActivity: [],
  clientActivityPagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  clientActivityLoading: false,
  clientActivityErrors: {},
  validSSN: [],
  validSSNError: {},
  validSSNLoading: false,
  checkEmailPayload: [],
  checkEmailError: {},
  checkEmailLoading: false,
  clientFieldTemplates: [],
  clientFieldTemplatesLoading: false,
  clientFieldTemplatesErrors: {},
  allClientList: [],
  allClientListLoading: false,
  allClientListErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const clientReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case CLIENT_UPSERT_REQUEST:
    case CLIENT_FETCH_REQUEST:
    case CLIENT_REGISTER_REQUEST:
    case CLIENT_ASSOCIATION_ADD_REQUEST:
    case CLIENT_FORGET_PASSWORD_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CLIENT_UPSERT_REQUEST_SUCCESS:
    case CLIENT_REGISTER_REQUEST_SUCCESS:
    case CLIENT_ASSOCIATION_ADD_REQUEST_SUCCESS:
    case CLIENT_FORGET_PASSWORD_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case CLIENT_CATEGORY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        category: action.data,
      });

    case CLIENT_TIMEZONE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        timeZone: action.data,
      });

    case CLIENT_STATE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        state: action.data,
      });

    case CLIENT_FILING_STATUS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        filingStatus: action.data,
      });

    case CLIENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
          showSizeChanger: true,
        },
      });

    case CLIENT_UPSERT_REQUEST_FAILURE:
    case CLIENT_FETCH_REQUEST_FAILURE:
    case CLIENT_DELETE_REQUEST_FAILURE:
    case CLIENT_REGISTER_REQUEST_FAILURE:
    case CLIENT_ASSOCIATION_ADD_REQUEST_FAILURE:
    case CLIENT_FORGET_PASSWORD_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CLIENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
        singlePayload: [],
        singleLoading: false,
        singleErrors: {},
        maxDatePayload: [],
        maxDateLoading: false,
        maxDateErrors: {},
      });

    case CLEAN_CLIENT_ERROR_PROPS:
      return Object.assign({}, state, {
        errors: {},
        singleErrors: {},
      });

    case CLIENT_DELETE_ERROR_CLEAN_REQUEST:
      return Object.assign({}, state, {
        deleteErrors: {},
      });

    case SINGLE_CLIENT_UPDATE_REQUEST:
    case SINGLE_CLIENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        singleLoading: true,
      });
    case SINGLE_CLIENT_UPDATE_REQUEST_SUCCESS:
    case SINGLE_CLIENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: action.data,
        singleErrors: {},
      });
    case SINGLE_CLIENT_UPDATE_REQUEST_FAILURE:
    case SINGLE_CLIENT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleLoading: false,
        singleErrors: action.error,
      });

    case MERGE_CLIENT_DETAIL_FETCH_REQUEST:
      return Object.assign({}, state, {
        mergeClientDetailLoading: true,
      });

    case MERGE_CLIENT_DETAIL_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        mergeClientDetailLoading: false,
        mergeClientDetail: action.data,
        mergeClientDetailErrors: {},
      });

    case MERGE_CLIENT_DETAIL_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        mergeClientDetailLoading: false,
        mergeClientDetailErrors: action.error,
      });

    case MERGE_CLIENT_DETAIL_CLEAN_REQUEST:
      return Object.assign({}, state, {
        mergeClientDetail: [],
        mergeClientDetailLoading: false,
        mergeClientDetailErrors: {},
      });

    case CLIENT_FILING_STATUS_YEAR_UPDATE_REQUEST:
      return Object.assign({}, state, {
        filingStatusYearLoading: true,
        filingStatusYearErrors: {},
      });

    case CLIENT_FILING_STATUS_YEAR_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        filingStatusYearLoading: false,
        filingStatusYearPayload: action.data,
        filingStatusYearErrors: {},
      });

    case CLIENT_FILING_STATUS_YEAR_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        filingStatusYearLoading: false,
        filingStatusYearErrors: action.error,
      });

    case CLEAN_CLIENT_FILING_STATUS_YEAR_PROPS:
      return Object.assign({}, state, {
        filingStatusYearPayload: [],
        filingStatusYearLoading: false,
        filingStatusYearErrors: {},
      });

    case DOCUMENT_SIGNER_FLIP_REQUEST:
      return Object.assign({}, state, {
        documentSignerFlipLoading: true,
        documentSignerFlipErrors: {},
      });

    case DOCUMENT_SIGNER_FLIP_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        documentSignerFlipLoading: false,
        documentSignerFlipErrors: {},
      });

    case DOCUMENT_SIGNER_FLIP_REQUEST_FAILURE:
      return Object.assign({}, state, {
        documentSignerFlipLoading: false,
        documentSignerFlipErrors: action.error,
      });

    case CLIENT_APPOINMENT_MAX_DATE_FETCH_REQUEST:
      return Object.assign({}, state, {
        maxDatePayload: true,
      });
    case CLIENT_APPOINMENT_MAX_DATE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        maxDateLoading: false,
        maxDatePayload: action.data,
        maxDateErrors: {},
      });
    case CLIENT_APPOINMENT_MAX_DATE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        maxDateLoading: false,
        maxDateErrors: action.error,
      });

    case CLIENT_DROPDOWN_FETCH_REQUEST:
      return Object.assign({}, state, {
        clientDropdownLoading: true,
      });
    case CLIENT_DROPDOWN_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        clientDropdownLoading: false,
        clientDropdownPayload: action.data,
        clientDropdownErrors: {},
      });
    case CLIENT_DROPDOWN_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        clientDropdownLoading: false,
        clientDropdownErrors: action.error,
      });

    case CLIENT_DROPDOWN_BY_TAX_REPRESENTATIVE_FETCH_REQUEST:
      return Object.assign({}, state, {
        clientDropdownByTaxRepresentativeLoading: true,
      });
    case CLIENT_DROPDOWN_BY_TAX_REPRESENTATIVE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        clientDropdownByTaxRepresentativeLoading: false,
        clientDropdownByTaxRepresentativePayload: action.data,
        clientDropdownByTaxRepresentativeErrors: {},
      });
    case CLIENT_DROPDOWN_BY_TAX_REPRESENTATIVE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        clientDropdownByTaxRepresentativeLoading: false,
        clientDropdownByTaxRepresentativeErrors: action.error,
      });

    case CLIENT_SSN_FETCH_REQUEST:
      return Object.assign({}, state, {
        clientSSNLoading: true,
      });
    case CLIENT_SSN_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        clientSSNLoading: false,
        clientSSNPayload: action.data,
        clientSSNErrors: {},
      });
    case CLIENT_SSN_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        clientSSNLoading: false,
        clientSSNErrors: action.error,
      });

    case CLIENT_DELETE_REQUEST:
      return Object.assign({}, state, {
        deleteLoading: true,
      });

    case CLIENT_DELETE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        deleteLoading: false,
        deleteErrors: {},
        deletePayload: action.data,
      });

    case CLIENT_DELETE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        deleteLoading: false,
        deleteErrors: action.error,
      });
    case SINGLE_CLIENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: [],
        singleErrors: {},
      });

    case ONBOARDING_CLIENT_DELETE_REQUEST:
      return Object.assign({}, state, {
        deleteOnboardingClientLoading: true,
      });

    case ONBOARDING_CLIENT_DELETE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        deleteOnboardingClientLoading: false,
        deleteOnboardingClientPayload: action.data,
        deleteOnboardingClientError: {},
      });

    case ONBOARDING_CLIENT_DELETE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        deleteOnboardingClientLoading: false,
        deleteOnboardingClientError: action.error,
      });

    case ONBOARDING_CLIENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        deleteOnboardingClientPayload: [],
        deleteOnboardingClientLoading: false,
        deleteOnboardingClientError: {},
      });

    case REQUEST_FOR_CLIENT_DELETE:
      return Object.assign({}, state, {
        deleteRequestLoading: true,
      });

    case REQUEST_FOR_CLIENT_DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleteRequestLoading: false,
        deleteRequest: action.data,
        deleteRequestErrors: {},
      });

    case REQUEST_FOR_CLIENT_DELETE_FAILURE:
      return Object.assign({}, state, {
        deleteRequestLoading: false,
        deleteRequestErrors: action.error,
      });

    case CONFIRM_CLIENT_DELETE_REQUEST:
      return Object.assign({}, state, {
        confirmDeleteLoading: true,
      });

    case CONFIRM_CLIENT_DELETE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        confirmDeleteLoading: false,
        confirmDelete: action.data,
        confirmDeleteErrors: {},
      });

    case CONFIRM_CLIENT_DELETE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        confirmDeleteLoading: false,
        confirmDeleteErrors: action.error,
      });

    case CLEAN_CLIENT_DELETE_PROPS:
      return Object.assign({}, state, {
        confirmDeleteLoading: false,
        confirmDelete: [],
        confirmDeleteErrors: {},
        deleteRequestErrors: {},
      });

    case ASSOCIATION_SUMMARY_FETCH_REQUEST:
      return Object.assign({}, state, {
        associationSummaryLoading: true,
      });

    case ASSOCIATION_SUMMARY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        associationSummaryLoading: false,
        associationSummary: action.data,
        associationSummaryErrors: {},
      });

    case ASSOCIATION_SUMMARY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        associationSummaryLoading: false,
        associationSummaryErrors: action.error,
      });

    case CLEAN_ASSOCIATION_SUMMARY:
      return Object.assign({}, state, {
        associationSummaryLoading: false,
        associationSummaryErrors: {},
        associationSummary: [],
      });

    case FETCH_CLIENTS_TERMS_AND_CONDITION_REQUEST:
      return Object.assign({}, state, {
        termsAndConditionLoading: true,
      });

    case FETCH_CLIENTS_TERMS_AND_CONDITION_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        termsAndConditionLoading: false,
        termsAndCondition: action.data,
        termsAndConditionErrors: {},
      });

    case FETCH_CLIENTS_TERMS_AND_CONDITION_REQUEST_FAILURE:
      return Object.assign({}, state, {
        termsAndConditionLoading: false,
        termsAndConditionErrors: action.error,
      });

    case UPDATE_TAXREPRESENTATIVE_IN_BULK_REQUEST:
      return Object.assign({}, state, {
        taxRepresentativeUpdating: true,
      });

    case UPDATE_TAXREPRESENTATIVE_IN_BULK_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taxRepresentativeUpdating: false,
        updateTaxRepresentative: action.data,
        taxRepresentativeUpdatingErrors: {},
      });

    case UPDATE_TAXREPRESENTATIVE_IN_BULK_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taxRepresentativeUpdating: false,
        taxRepresentativeUpdatingErrors: action.error,
      });

    case CLEAN_TAXREPRESENTATIVE_CHANGE_STATUS:
      return Object.assign({}, state, {
        taxRepresentativeUpdating: false,
        updateTaxRepresentative: [],
        taxRepresentativeUpdatingErrors: {},
      });

    case FETCH_CONDITIONS_TO_UPDATE_CLIENT_REQUEST:
      return Object.assign({}, state, {
        bulkUpdateLoading: true,
      });

    case FETCH_CONDITIONS_TO_UPDATE_CLIENT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        bulkUpdateLoading: false,
        bulkUpdatePayload: action.data,
        bulkUpdateError: {},
      });

    case FETCH_CONDITIONS_TO_UPDATE_CLIENT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        bulkUpdateLoading: false,
        bulkUpdateError: action.error,
      });

    case FETCH_CLIENT_ACTIVITY_LOG_REQUEST:
      return Object.assign({}, state, {
        clientActivityLoading: true,
      });
    case FETCH_CLIENT_ACTIVITY_LOG_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        clientActivityLoading: false,
        clientActivityPagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
          showSizeChanger: true,
        },
        clientActivity: action.data,
        clientActivityErrors: {},
      });

    case FETCH_CLIENT_ACTIVITY_LOG_REQUEST_FAILURE:
      return Object.assign({}, state, {
        clientActivityLoading: false,
        clientActivityErrors: action.error,
      });

    case DELETE_CLIENT_PROPS_CLEAN:
      return Object.assign({}, state, {
        deleteRequest: [],
      });

    case CHECK_VALID_SSN_REQUEST:
      return Object.assign({}, state, {
        validSSNLoading: true,
      });

    case CHECK_VALID_SSN_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        validSSNLoading: false,
        validSSN: action.data,
        validSSNError: {},
      });

    case CHECK_VALID_SSN_REQUEST_FAILURE:
      return Object.assign({}, state, {
        validSSNLoading: false,
        validSSNError: action.error,
      });

    case CLEAN_SSN_VALIDATION:
      return Object.assign({}, state, {
        validSSNLoading: false,
        validSSN: [],
        validSSNError: {},
      });

    case CHECK_VALID_EMAIL_REQUEST:
      return Object.assign({}, state, {
        checkEmailLoading: true,
      });

    case CHECK_VALID_EMAIL_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        checkEmailLoading: false,
        checkEmailPayload: action.data,
        checkEmailError: {},
      });

    case CHECK_VALID_EMAIL_REQUEST_FAILURE:
      return Object.assign({}, state, {
        checkEmailLoading: false,
        checkEmailError: action.error,
        checkEmailPayload: [],
      });

    case CLEAN_EMAIL_REQUEST:
      return Object.assign({}, state, {
        checkEmailLoading: false,
        checkEmailPayload: [],
        checkEmailError: {},
      });

    case CLIENT_FIELD_TEMPLATE_FETCH_REQUEST:
      return Object.assign({}, state, {
        clientFieldTemplatesLoading: true,
      });

    case CLIENT_FIELD_TEMPLATE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        clientFieldTemplatesLoading: false,
        clientFieldTemplates: action.payload,
        clientFieldTemplatesErrors: {},
      });

    case CLIENT_FIELD_TEMPLATE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        clientFieldTemplatesLoading: false,
        clientFieldTemplates: [],
        clientFieldTemplatesErrors: action.error,
      });
    case CLIENT_ALL_LIST_FETCH_REQUEST:
      return Object.assign({}, state, {
        allClientListLoading: true,
      });

    case CLIENT_ALL_LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        allClientListLoading: false,
        allClientList: action.payload,
        allClientListErrors: {},
      });

    case CLIENT_ALL_LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        allClientListLoading: false,
        allClientList: [],
        allClientListErrors: action.error,
      });

    default:
      return state;
  }
};

export default clientReducer;

const INITIAL_STATE2 = {
  payload: [],
  loading: false,
  errors: {},
  unlinkedBusinessClients: [],
  unlinkedBusinessClientsLoading: false,
  unlinkedBusinessClientsErrors: {},
  linkAccount: [],
  linkAccountLoading: false,
  linkAccountErrors: {},
  singleAssociation: [],
  singleAssociationErrors: {},
  singleAssociationLoading: false,
  associationUpdate: [],
  associationUpdateErrors: {},
  associationUpdateLoading: false,
  associateShare: [],
  associateShareLoading: false,
  associateShareError: {},
};

export const clientAssociationReducer = (state, action) => {
  state = state || INITIAL_STATE2;

  switch (action.type) {
    case CLIENT_ASSOCIATION_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CLIENT_ASSOCIATION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case CLIENT_ASSOCIATION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SINGLE_ASSOCIATION_FETCH_REQUEST:
      return Object.assign({}, state, {
        singleAssociationLoading: true,
      });

    case SINGLE_ASSOCIATION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleAssociationLoading: false,
        singleAssociation: action.data,
        singleAssociationErrors: {},
      });

    case SINGLE_ASSOCIATION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleAssociationLoading: false,
        singleAssociationErrors: action.error,
      });

    case ASSOCIATION_UPSERT_REQUEST:
      return Object.assign({}, state, {
        associationUpdateLoading: true,
      });

    case ASSOCIATION_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        associationUpdateLoading: false,
        associationUpdate: action.data,
        associationUpdateErrors: {},
      });

    case ASSOCIATION_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        associationUpdateLoading: false,
        associationUpdateErrors: action.error,
      });

    case CLIENT_ASSOCIATION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    case UNLINKED_BUSINESS_CLIENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        unlinkedBusinessClientsLoading: true,
      });

    case UNLINKED_BUSINESS_CLIENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        unlinkedBusinessClientsLoading: false,
        unlinkedBusinessClients: action.data,
        unlinkedBusinessClientsErrors: {},
      });

    case UNLINKED_BUSINESS_CLIENT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        unlinkedBusinessClientsLoading: false,
        unlinkedBusinessClients: [],
        unlinkedBusinessClientsErrors: action.error,
      });

    case LINK_ACCOUNT_REQUEST:
      return Object.assign({}, state, {
        linkAccountLoading: true,
      });

    case LINK_ACCOUNT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        linkAccountLoading: false,
        linkAccount: action.data,
        linkAccountErrors: {},
      });

    case LINK_ACCOUNT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        linkAccountLoading: false,
        linkAccount: [],
        linkAccountErrors: action.error,
      });

    case CLEAN_LINK_PROPS:
      return Object.assign({}, state, {
        unlinkedBusinessClients: [],
        unlinkedBusinessClientsLoading: false,
        unlinkedBusinessClientsErrors: {},
        linkAccount: [],
        linkAccountLoading: false,
        linkAccountErrors: {},
      });

    case CLIENT_ASSOCIATION_SINGLE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singleAssociation: [],
        singleAssociationErrors: {},
        singleAssociationLoading: false,
      });

    case ASSOCIATION_SHARE_REQUEST:
      return Object.assign({}, state, {
        associateShareLoading: true,
      });

    case ASSOCIATION_SHARE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        associateShareLoading: false,
        associateShare: action.data,
        associateShareError: {},
      });

    case ASSOCIATION_SHARE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        associateShareLoading: false,
        associateShare: [],
        associateShareError: action.error,
      });

    case CLEAN_TAX_FILING_STATUS:
      return Object.assign({}, state, {
        filingStatus: [],
      });

    default:
      return state;
  }
};
